module.exports = __webpack_public_path__ + "static/media/timeline-acao-prep.6b51f2f3.svg";